const PREFIX = 'SUBSCRIPTION_EXPIRED'

export const SUBSCRIPTION_EXPIRED_SHOW_MODAL = `${PREFIX}_SHOW_MODAL`

export const SUBSCRIPTION_EXPIRED_HIDE_MODAL = `${PREFIX}_HIDE_MODAL`

export const IS_SUBSCRIPTION_EXPIRED = 'IS_SUBSCRIPTION_EXPIRED'

export const ASK_SHOW_SUBSCRIPTION_EXPIRED = 'ASK_SHOW_SUBSCRIPTION_EXPIRED'

export const SUBSCRIPTION_EXPIRED_SET_NEXT_ACTION = `${PREFIX}_SET_NEXT_ACTION`

export const SUBSCRIPTION_EXPIRED_CLOSE_MODAL = `${PREFIX}_CLOSE_MODAL`



// WEBPACK FOOTER //
// ./app/actions/subscriptionExpired/constants.js